import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';
import { Input } from '@material-ui/core';

const InputStyled = styled(Input)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`;
const Header = styled.div`
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 500;
`;

const UpdateReleaseNoteModal = ({ isOpen, handleClose, rowData, handleSave }) => {
    const [editedData, setEditedData] = useState({ app_version: '', text: '' });

    useEffect(() => {
        if (rowData?.app_version) {
            setEditedData(prevData => ({
                ...prevData,
                app_version: rowData.app_version
            }));
        }
    }, [rowData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSaveChanges = async () => {
        handleSave(rowData.id, editedData);
        handleClose();
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogContent>
                <Header>App Version</Header>
                <InputStyled
                    type="text"
                    disableUnderline
                    fullWidth
                    value={editedData?.app_version}
                    disabled
                />
                <TextField
                    label="Release Note"
                    name="text"
                    defaultValue={rowData?.text}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    multiline
                    rows={4}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSaveChanges} color="primary">
                    Save Changes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UpdateReleaseNoteModal;
